import { render, staticRenderFns } from "./EmployeeDetailsCardExport.vue?vue&type=template&id=4ffa2458&"
import script from "./EmployeeDetailsCardExport.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EmployeeDetailsCardExport.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports